import { CONFIG } from "../../config/index";

export const taskManagerStore = [
    {
        title: "getReassignUsersData",
        actionPrefix: "getReassignUsers",
        errorMessage: "Failed to get the users list!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}${payload?.apiUrl || "/admin/master/users/get/all"}`,
        },
    },
    {
        title: "getTaskPrioritiesData",
        actionPrefix: "getTaskPriorities",
        errorMessage: "Failed to get the task priority options!",
        requestData: {
            method: "GET",
            buildUrl: (payload) => `${CONFIG.NOTIFICATION_ROUTE_PROD}/tasks/priorities`,
        },
    },
    {
        title: "getTaskTypeCountsData",
        actionPrefix: "getTaskTypeCounts",
        errorMessage: "Failed to get the task type counts!",
        requestData: {
            method: "GET",
            buildUrl: (payload) => `${CONFIG.NOTIFICATION_ROUTE_PROD}/tasks/type-counts?assignee=${payload.assignee}${payload.status ? `&status=${payload.status}` : ""}`,
        },
    },
    {
        title: "getTeamTaskCountsData",
        actionPrefix: "getTeamTaskCounts",
        errorMessage: "Failed to get the team task counts!",
        requestData: {
            method: "GET",
            buildUrl: () => `${CONFIG.NOTIFICATION_ROUTE_PROD}/tasks/team-counts`,
        },
    },
    {
        title: "getTaskListData",
        actionPrefix: "getTaskList",
        errorMessage: "Failed to get the task list!",
        requestData: {
            method: "GET",
            buildUrl: (payload) => {
                const params = new URLSearchParams();
                if (payload.assignee) params.set("assignee", payload.assignee);
                if (payload.taskType) params.set("taskType", payload.taskType);
                if (payload.priority) params.set("priority", payload.priority);
                if (payload.status) params.set("status", payload.status);
                params.set("page", payload.page || 1);
                params.set("limit", payload.limit || 20);
                params.set("sort", payload.sort || "newest");
                return `${CONFIG.NOTIFICATION_ROUTE_PROD}/tasks?${params.toString()}`;
            },
        },
    },
    {
        title: "getTaskDetailsData",
        actionPrefix: "getTaskDetails",
        errorMessage: "Failed to get the task details!",
        requestData: {
            method: "GET",
            buildUrl: (payload) => `${CONFIG.NOTIFICATION_ROUTE_PROD}/tasks/${payload.id}/details`,
        },
    },
    {
        title: "getChildTaskDetailsData",
        actionPrefix: "getChildTaskDetails",
        errorMessage: "Failed to get the task details!",
        requestData: {
            method: "GET",
            buildUrl: (payload) => `${CONFIG.NOTIFICATION_ROUTE_PROD}/tasks/${payload.id}/details`,
        },
    },
    {
        title: "getTaskWatchersData",
        actionPrefix: "getTaskWatchers",
        errorMessage: "Failed to get the task watchers!",
        requestData: {
            method: "GET",
            buildUrl: (payload) => `${CONFIG.NOTIFICATION_ROUTE_PROD}/tasks/${payload.taskId}/watchers`,
        },
        responseData: {
            successDataHandler: (response) => response?.data,
        },
    },
    {
        title: "addTaskWatcherData",
        actionPrefix: "addTaskWatcher",
        message: "Watcher added successfully",
        errorMessage: "Failed to add the watcher!",
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.taskId;
                return payload;
            },
            buildUrl: (payload) => `${CONFIG.NOTIFICATION_ROUTE_PROD}/tasks/${payload.taskId}/watchers`,
        },
        responseData: {
            successDataHandler: (response) => response?.data,
        },
    },
    {
        title: "removeTaskWatcherData",
        actionPrefix: "removeTaskWatcher",
        message: "Watcher removed successfully",
        errorMessage: "Failed to remove the watcher!",
        requestData: {
            method: "DELETE",
            updatePayload: ({ ...payload }) => {
                delete payload.taskId;
                delete payload.userId;
                return payload;
            },
            buildUrl: (payload) => `${CONFIG.NOTIFICATION_ROUTE_PROD}/tasks/${payload.taskId}/watchers/${payload.userId}`,
        },
        responseData: {
            responseHandler: (response) => (response?.status === 204 || response?.status === 200 ? { success: true } : { failure: true }),
        },
    },
    {
        title: "changeTaskPriorityData",
        actionPrefix: "changeTaskPriority",
        message: "Priority updated successfully",
        errorMessage: "Failed to update the priority!",
        requestData: {
            method: "PATCH",
            updatePayload: ({ ...payload }) => {
                delete payload.id;
                return payload;
            },
            buildUrl: (payload) => `${CONFIG.NOTIFICATION_ROUTE_PROD}/tasks/${payload.id}/priority`,
        },
    },
    {
        title: "completeTaskData",
        actionPrefix: "completeTask",
        message: "Task marked as closed successfully",
        errorMessage: "Failed to close the task!",
        requestData: {
            method: "POST",
            updatePayload: ({ ...payload }) => {
                delete payload.id;
                return payload;
            },
            buildUrl: (payload) => `${CONFIG.NOTIFICATION_ROUTE_PROD}/tasks/${payload.id}/complete`,
        },
    },
    {
        title: "reassignTaskData",
        actionPrefix: "reassignTask",
        message: "Task reassigned successfully",
        errorMessage: "Failed to reassign the task!",
        requestData: {
            method: "POST",
            updatePayload: ({ ...payload }) => {
                delete payload.id;
                return payload;
            },
            buildUrl: (payload) => `${CONFIG.NOTIFICATION_ROUTE_PROD}/tasks/${payload.id}/reassign`,
        },
    },
];
